<div
  class="wrapper"
  [ngClass]="isExpand ? 'ces-menu-collapse' : 'ces-menu-collapsed'"
>
  <ces-header
    appName="SSO-ADMIN"
    (onHeaderMenuClick)="headerMenu($event)"
    logoRedirectUrl="https://ces-ltd.com/"
  >
    <header-end>
      <div class="header-right">
        <div
          header-end-item
          class="header-right-item"
        >
          <div
            class="goto-app-selection theme-switcher-btn"
            title="Go To applications"
            (click)="redirectApp()"
          >
            <i class="icon icon-app-drawer"></i>
          </div>
        </div>
        <div
          header-end-item
          class="header-right-item color-theme-switcher"
        >
          <div class="ces-theme-switcher theme-switcher">
            <button
              [attr.title]="'Switch to ' + (switchThemeToggle ? 'light theme' : 'dark theme')"
              type="button"
              class="theme-switcher-btn"
              (click)="switchTheme()"
              [class.dark-theme-switched]="switchThemeToggle"
            >
              <i
                class="icon"
                [ngClass]="switchThemeToggle ? 'icon-sun' : 'icon-moon'"
              ></i>
            </button>
          </div>
        </div>

        <div
          header-end-item
          class="header-right-item header-notification d-none"
        >
          <ces-badge
            badgeType="badge"
            customClass="right-action-btn"
            icon="icon-bell"
            [count]="55"
          ></ces-badge>
        </div>
        <div
          header-end-item
          class="header-right-item"
        >
          <profile-menu
            [menuItems]="appliedUserMenu"
            [userName]="userName"
            [avatarName]="profileUrl ? '' : avatarName"
            [userType]="userType"
            [profileImageUrl]="profileUrl"
          ></profile-menu>
        </div>
      </div>
    </header-end>
  </ces-header>

  <ces-side-nav
    [menuItems]="allSidebarMenus"
    [logoImgForExpandedView]="logoImgExpand"
    [logoImgForCollapseView]="logoImgCollapse"
    (onCollapse)="onSidebarCollapse($event)"
    [expandMenu]="isExpand"
    (onMenuClick)="menuClick()"
    logoRedirectUrl="https://ces-ltd.com/"
  >
  </ces-side-nav>

  <!--Container Main start-->
  <div class="height-100 ces-layout main-content">
    <!--main content-->
    <router-outlet></router-outlet>
  </div>
  <!--Container Main end-->

  <!--footer right text-->
  <ces-footer alignment="center"></ces-footer>
  <!--end footer right text-->
</div>
